/*
 * Replaces periods with a considered-safe group of characters
 * from the array defined in the second parameter
 */
const makeSpecialCasesSafe = (string, cases) => {
  let safe = string;
  let regex;
  cases.forEach((cas) => {
    const replacement = cas.replace(/\./g, '****');
    regex = new RegExp(cas, 'g');
    safe = safe.replace(regex, replacement);
  });

  return safe;
};
/*
 * Restores periods to the array defined in the second parameter
 */
const revertSpecialCases = (string, cases) => {
  let reverted = string;
  let regex;
  cases.forEach((cas) => {
    const replacement = cas.replace(/\./g, '\\*\\*\\*\\*');
    regex = new RegExp(replacement, 'g');
    reverted = reverted.replace(regex, cas);
  });
  return reverted;
};

const cleanText = text => text.replace(/\s+/g, ' ');

const splitText = (text) => {
  let split = text.trim();
  // Handle special cases - words that contain periods
  // TO DO - more coverate with this list
  const specialCases = ['Dr.', 'Mr.', 'Mrs.', 'St. ', 'Rd. ', 'Ct. '];
  const re = /(["']?([А-Я]|[A-ZÁÉÍÓÚÜÑÇ])[^.?!]+((?![.?!]['"]?\s["']?([А-Я]|[A-ZÁÉÍÓÚÜÑÇ]|[¿¡])[^.?!]).)+[.?!'"]+[.?!'"]?)/igm;
  const reZh = /([｡。！？])/gm;

  split = makeSpecialCasesSafe(split, specialCases);
  split = split.replace(re, '$1|');
  split = revertSpecialCases(split, specialCases);
  split = split.replace(reZh, '$1|');
  split = split.split('|');
  split = split.filter(v => v !== '');
  return split;
};

const formatText = (text, lang = 'en-gb') => {
  let formatted = text;
  formatted = cleanText(formatted);
  formatted = splitText(formatted, lang);

  if (formatted.length === 0) {
    return [{
      source: '',
      results: [],
      audioBuffer: null,
    }];
  }

  const formattedText = formatted.map((sentence) => {
    const singularText = {
      source: sentence.trim(),
      results: [],
      audioBuffer: null,
    };

    return singularText;
  });

  return formattedText;
};

export default formatText;



// WEBPACK FOOTER //
// ./src/modules/text-helpers.js